import React from 'react';
import { connect } from 'react-redux';
import './reviewOrders.scss';
import ReviewCollectionData from './reviewCollectionData';
import { ServiceEndPoints } from '../../../utils/constants/ApiConstant';
import { customTableSort, getCustomerAccountID } from '../../../utils/helperFunctions';
import { withRouter } from 'react-router-dom';
import { axiosConfig } from '../../../api/axios';
import * as actions from '../../../store/actions/index';

class ReviewCollections extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabIndex: 0,
      totalRecords: 0,
      isSearched: false,
      columns: [
        { title: 'id', field: 'id', hidden: true, width: 0 },
        {
          title: 'Customer ref.',
          field: 'customerReference',
          // customSort: (a, b) => customTableSort(a.customerReference, b.customerReference),
          render: (row) => <div onClick={() => this.customerNumberClicked(row)}>{row.customerReference}</div>,
          width: 120,
          sorting: true,
        },
        {
          title: 'Business/Customer name',
          field: 'customerName',
          render: (row) => <div onClick={() => this.customerNumberClicked(row)}>{row.customerName}</div>,
          sorting: true,
          width: 220,
        },
        {
          title: 'Collection postal code',
          field: 'postalCode',
          render: (row) => <div onClick={() => this.customerNumberClicked(row)}>{row.postalCode}</div>,
          sorting: true,
          width: 200,
        },
        {
          title: 'Source',
          field: 'source',
          render: (row) => <div onClick={() => this.customerNumberClicked(row)}>{row.source}</div>,
          sorting: false,
          width: 100,
        },
        {
          title: 'Sub-source',
          field: 'subSource',
          sorting: false,
          width: 100,
        },
        {
          title: 'Contact',
          field: 'contact',
          render: (row) => <div onClick={() => this.customerNumberClicked(row)}>{row.contact}</div>,
          sorting: true,
          width: 80,
        },
        {
          title: 'Collection date',
          field: 'dispatchDate',
          render: (row) => <div onClick={() => this.customerNumberClicked(row)}>{row.dispatchDate}</div>,
          sorting: true,
          width: 90,
        },
      ],
      orders_totalCount: 0,
      pageSize: 10,
      pageNumber: 0,
      isLoading: false,
      ordersData: [],
    };
    this.onClickSetSortOrder = this.onClickSetSortOrder.bind(this);
  }

  customerNumberClicked = (rowData) => {
    this.props.history.push({
      pathname: `/shipment/collectionRequest/${rowData.id}/true/false`,
      state: {
        isScanFlag: this.props.isScanFlag,
      }
    });
  };

  componentDidMount() {
    this.props.setSortOrder(``);
    this.getOrdersData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.tabIndex === 3 && ((this.props.isSearched !== prevProps.isSearched || this.props.refreshList)
      || (this.props.addressBookSearchParams.split('=')[0] !== prevProps.addressBookSearchParams.split('=')[0]
        && this.props.addressBookSearchParams.split('=')[1] !== '' && prevProps.addressBookSearchParams !== ''))) {
      this.setState({ pageSize: this.state.pageSize, pageNumber: 0 }, () => {
        this.getOrdersData();
      });
    }
  }

  getOrdersData() {
    this.props.setRefreshList(false);
    this.setState({ isLoading: true });
    setTimeout(() => {
    const offset = this.state.pageSize * this.state.pageNumber;
    const limit = this.state.pageSize;
    axiosConfig
      .get(this.getUrl(offset, limit))
      .then((res) => {
        this.formatReviewCollectionData(res.data);
      })
      .catch((err) => {
        console.log(err);
        this.formatReviewCollectionData([]);
      })
      .finally(() => this.setState({ isLoading: false }));
    }, 0);
  }

  getUrl = (offset, limit) => {
    let url = `${ServiceEndPoints.getOrders
      }?organization=${getCustomerAccountID()}&isValid=false&iscollectionrequest=true`;
    url += '&offset=' + offset;
    url += '&limit=' + limit;
    url += this.props.sortOrderState;
    url += this.props.addressBookSearchParams;
    return url;
  };

  formatReviewCollectionData = (result) => {
    let final_data = [];
    result?.orders?.forEach((element) => {
      const shipmentDetails = element?.shipmentModel?.shipments?.[0]?.shipmentDetails;
      const pickupAddress = element?.shipmentModel?.pickupAddress ?? {};

      final_data.push({
        id: element.id,
        customerReference: (element || {}).referenceNumber,
        customerName: pickupAddress.companyName || pickupAddress.name,
        source: element.sourceReference,
        subSource: element.subSource,
        alternateReference: shipmentDetails?.customerRef2,
        contact: pickupAddress.name,
        postalCode: pickupAddress.postalCode,
        dispatchDate: element?.shipmentModel?.pickup?.date,
      });
    });
    if (
      this.props.addressBookSearchParams !== '' &&
      this.props.addressBookSearchParams?.split('=')?.[1] &&
      this.props.addressBookSearchParams !== '&customerReferenceNumber=' &&
      this.props.addressBookSearchParams !== '&alternateReference=' &&
      final_data.length === 1
    ) {
      this.props.history.push({
        pathname: `/shipment/collectionRequest/${final_data[0].id}/true/false`,
        state: {
          isScanFlag: this.props.isScanFlag,
        }
      });
    }
    this.setState({
      ordersData: final_data,
      orders_totalCount: result.totalRecords ? result.totalRecords : 0,
    });
    this.props.reviewCollectionsTotalCounts(result.totalRecords ? result.totalRecords : 0);
  };

  onPageNumChange(pageNum) {
    this.setState({ pageNumber: pageNum }, () => {
      this.getOrdersData();
    });
  }

  onPageSizeChange(pageSize) {
    this.setState({ pageSize: pageSize }, () => {
      this.getOrdersData();
    });
  }

  onClickSetSortOrder(orderIn, orderBy) {
    if(orderIn === 'asc')
    {
      this.props.setSortOrder(`&sortBy=${orderBy}&sortIn=ascending`);
    }
    else if(orderIn === 'desc'){
      this.props.setSortOrder(`&sortBy=${orderBy}&sortIn=descending`);
    }
    else{
      this.props.setSortOrder(``);
    }
    this.setState({ pageNumber: 0 });
    this.getOrdersData();
  }

  render() {
    return (
      <ReviewCollectionData
        rows={this.state.ordersData}
        deleteSelectedOrder={this.props.deleteSelectedOrder}
        columns={this.state.columns}
        empty_DataSource_Message="Collections not found"
        tableRef={this.props.tableRef}
        Dialogtitle="Delete collections"
        fullWidth
        totalCount={this.state.orders_totalCount}
        pageSize={this.state.pageSize}
        count={this.state.orders_totalCount}
        isLoading={this.state.isLoading}
        inBuiltEvents={{
          onChangeRowsPerPage: (e) => this.onPageSizeChange(e),
          onChangePage: (a) => this.onPageNumChange(a),
        }}
        page={this.state.pageNumber}
        deleteAllOrder={this.props.deleteAllOrder}
        isCollectionRequest={true}
        isValid={false}
        tableLayout="fixed"
        onClickSetSortOrder={this.onClickSetSortOrder}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userDetails: state.auth.userDetails,
    addressBookSearchParams: state.searchParams,
    sortOrderState: state.common.sortOrderState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSortOrder: (data) => {
      dispatch(actions.setSortOrderState(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReviewCollections));
